<template>
    <div class="card mb-5  " >
        <div class="card-body">
            <h5 class="card-title">{{ blog.firstName }}</h5>
            <h5 class="card-title">{{ blog.lastName }}</h5>
            <pre class="descreption">{{ blog.email }}</pre>
            <pre class="descreption">{{ blog.message }}</pre>
        </div>
        <div class="card-body">
            <button type="button" class="btn btn-light me-2" @click="deleteblog" >Supprimer</button>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import APIs from "@/../config";
export default {
    name : "BlogCard",
    data(){
        return {
            imgUrl : APIs.API_IMAGES
        }
    },
    props : {
        blog : Object
    },
    methods : {
        deleteblog(){
            var get_token = localStorage.getItem('token')
            var user_id = localStorage.getItem('user_id')  
            this.$swal.fire({
            title: 'Voulez-vous vraiment supprimer !',
            text: "",
            icon: 'warning',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, suprimer'
            })
            .then((result) => {
            if (result.isConfirmed) {
               axios.delete(`${APIs.API_URL}/contact/${user_id}/${this.blog._id}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${get_token}`
                        }
                    }
                )
                .then(() => {
                    this.$swal.fire(
                    'supprimée',
                    '',
                    'success'
                    )
                    this.$emit("refresh")
                })
                .catch(function (error) {
                    console.log(error);
                });
            }
            })
        }
    }
}
</script>

<style>
    .card-img-top {
        object-fit: cover;
    }
    .descreption {
        font-family: "Poppins", sans-serif;
        color: #005E6E;
        font-weight: 300;
        white-space: pre-wrap;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>